import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=00b367a5&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=00b367a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b367a5",
  null
  
)

export default component.exports